import * as React from 'react';
import FinancialFilingDataGrid from './FinancialFilingDataGrid';

function ProxyStatements({filings} :any) {
  return (
    <div className="col-lg-6 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Proxy Statements</h4>
          <p className="card-description">Important events, shareholder votes, executive compensation</p>
          <div>
            { filings?.data['DEF14A']?.length > 0  ?
            <FinancialFilingDataGrid
              data={filings.data['DEF14A']}
            />
            : <p className="card-description">There are no proxy statements available</p> }
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProxyStatements;
